import css from 'styled-jsx/css';

export default css`
 :global(.ShapeWrapper .dotBadge) {
  border: 2px solid var(--color-gp--white);
  border-radius: 100%;
  position: absolute;
  background-color: var(--color-gp--pipper);
  top: 2px;
  right: 3px;
  width: 12px;
  height: 12px;
}
:global(.ShapeWrapper) {
  outline: none;
  vertical-align: top;
  position: relative;
  margin: auto;
}
:global(.ShapeWrapper.sizeXS) {
  width: 30px;
}
:global(.ShapeWrapper.sizeS) {
  width: 40px;
}
:global(.ShapeWrapper.sizeM) {
  width: 62px;
}
:global(.ShapeWrapper.sizeL) {
  width: 71px;
}
:global(.ShapeWrapper.sizeXL) {
  width: 100px;
}
:global(.ShapeWrapper .shape) {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
:global(.ShapeWrapper .shape.Circle) {
  border-radius: 100%;
}
:global(.ShapeWrapper .shape.Potato) {
  border-radius: 43%;
}
:global(.ShapeWrapper .shape.sizeXS .shapeCombo) {
  width: 30px;
  height: 30px;
  font-size: 10px;
}
:global(.ShapeWrapper .shape .shapeCombo) {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
:global(.ShapeWrapper .shape.sizeS .shapeCombo) {
  width: 40px;
  height: 40px;
  font-size: 1.5rem;
}
:global(.ShapeWrapper .shape.sizeM .shapeCombo) {
  width: 62px;
  height: 62px;
  font-size: 1.875rem;
}
:global(.ShapeWrapper .shape.sizeL .shapeCombo) {
  width: 71px;
  height: 71px;
  font-size: 2rem;
}
:global(.ShapeWrapper .shape.sizeXL .shapeCombo) {
  width: 100px;
  height: 100px;
  font-size: 2.125rem;
}
:global(.ShapeWrapper .BallOutsideLabel) {
  font-size: 1rem;
  color: var(--color-gp--blue);
  margin-top: 11px;
}
:global(.ShapeWrapper .shape.Soft) {
  background-color: var(--color-gp--white);
}
:global(.ShapeWrapper .shape.Solid) {
  color: var(--color-gp--white);
  font-family: var(--light-font);
}
:global(.ShapeWrapper .shape.Transparent) {
  color: var(--color-gp--white);
  border: 1px solid var(--color-gp--white);
  background-color: transparent;
}
/* shape - MUSTARD */
:global(.ShapeWrapper .shape.Mustard.Solid) {
  background-color: var(--color-gp--egg);
}
:global(.ShapeWrapper .shape.Mustard.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--egg);
  border: 1px solid var(--color-gp--egg);
}
/* shape - GREEN */
:global(.ShapeWrapper .shape.Green.Solid) {
  background-color: var(--color-gp--green);
  font-size: 1.375rem;
}
:global(.ShapeWrapper .shape.Green.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--green);
  border: 1px solid var(--color-gp--green);
}
/* shape - BLUE */
:global(.ShapeWrapper .shape.Blue.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--blue);
  border: 1px solid var(--color-gp--blue);
}
/* shape - RED */
:global(.ShapeWrapper .shape.Red.Solid) {
  background-color: var(--color-gp--pipper);
}
:global(.ShapeWrapper .shape.Red.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--pipper);
  border: 1px solid var(--color-gp--pipper);
}
/* shape - ORANGE */
:global(.ShapeWrapper .shape.Orange.Solid) {
  background-color: var(--color-gp--egg);
}
:global(.ShapeWrapper .shape.Orange.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--egg);
  border: 1px solid var(--color-gp--egg);
}
/* shape - WHITE */
:global(.ShapeWrapper .shape.White.Solid){
  background-color: var(--color-gp--white);
  color: var(--color-gp--blue);
}
:global(.ShapeWrapper .shape.White.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--blue);
  border: 1px solid var(--color-gp--blue);
}
/* shape - GREY */
:global(.ShapeWrapper .shape.Grey.Solid) {
  background-color: var(--color-gp--grey3);
}
:global(.ShapeWrapper .shape.Grey.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--grey3);
  border: 1px solid var(--color-gp--grey3);
}
/* shape - PINK */
:global(.ShapeWrapper .shape.Pink.Solid) {
  background-color: var(--color-gp--pink);
}
:global(.ShapeWrapper .shape.Pink.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--pink);
  border: 1px solid var(--color-gp--pink);
}
/* shape - BLACK */
:global(.ShapeWrapper .shape.Black.Solid) {
  background-color: var(--color-gp--black);
}
:global(.ShapeWrapper .shape.Black.Soft) {
  background-color: var(--color-gp--white);
  color: var(--color-gp--black);
  border: 1px solid var(--color-gp--black);
}
/* shape - PRIORIT */
:global(.ShapeWrapper .shape.Priority.Solid) {
  background-color: var(--color-gp--priority);
}
:global(.ShapeWrapper .shape.Priority.Soft) {
  background-color: var(--color-gp--priority);
  color: var(--color-gp--white);
  border: 1px solid var(--color-gp--white);
}
:global(.wrapperClass-pending) {
  margin-top: 0px;
  padding-top: 0.9rem;
}
`;
